import headerBg from '@/assets/images/active/mitu/order/head/header_bg1.png';
import headerBg2 from '@/assets/images/active/mitu/order/head/header_bg.png';
import officeBtn from '@/assets/images/active/mitu/order/head/offical.png';
import loginBtn from '@/assets/images/active/mitu/order/head/login.png';
import accountBtn from '@/assets/images/active/travel/header/btn_07.png';
import activeBtn from '@/assets/images/active/travel/header/btn_09.png';
import logoutBtn from '@/assets/images/active/mitu/order/head/logoutBtn.png';
import loadBtn from '@/assets/images/active/travel/header/btn_10.png';

export const headerConfig = {
  not_logged_in: {
    background_image: headerBg2,
    style: 'height:142px'
  },
  logged_in: {
    background_image: headerBg,
    main_title_color: '#25503A',
    sub_title_color: '#25503A',
    tips_color: '#825339',
    game_name: '迷途之光'
  },
  operation_btn: {
    office_website: {
      width: '',
      height: '',
      background_image: '',
      img: officeBtn,
      style: 'top: 0.25rem',
      link: 'https://mtzg.qingcijoy.com/'
    },
    login: {
      width: '',
      height: '',
      background_image: '',
      img: loginBtn,
      style: 'top: 0.25rem',
    },
    change_account: {
      width: '',
      height: '',
      background_image: '',
      img: accountBtn,
      style: 'top: 0.25rem'
    },
    join_active: {
      width: '',
      height: '',
      background_image: '',
      img: activeBtn,
      style: 'top: 0.25rem',
      link: 'https://qcg.ink/XrLOO4'
    },
    logout: {
      width: '',
      height: '',
      img: logoutBtn,
      style: 'top: 0.25rem'
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/mitu/order/headerConfig.js